<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>工资模块</el-breadcrumb-item>
            <el-breadcrumb-item>员工月工资</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="inputDiv">
      <div class="inputDiv">
        <div>
          员工名称：
          <el-input v-model="staffName" style="width: unset;" placeholder="请输入员工名称"></el-input>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          员工电话：
          <el-input v-model="tel" style="width: unset;" placeholder="请输入员工电话"></el-input>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          选择时间:
          <el-date-picker v-model="moment" style="width: 200px;" type="month" placeholder="选择月"></el-date-picker>
        </div>
      </div>
    </div>
    <div class="inputDiv">
      <div class="inputDiv" style="width: 70%">
        <div>
          <span>本月总工资：{{totalSalary}}（元）</span>
          <span style="margin-left: 20px">确定工资：{{totalCheckSalary}}（元）</span>
          <span style="margin-left: 20px">本月总工资：{{totalUncheckSalary}}（元）</span>
        </div>
      </div>
      <div class="inputDiv" style="width: 30%">
        <el-button type="primary" class="widthButton" @click="search">查询</el-button>
        <!-- <el-button type="primary" class="widthButton">新增</el-button> -->
        <el-button type="primary" class="widthButton" @click="salaryExports">导出</el-button>
      </div>
    </div>

    <el-table :data="tableData" border @row-click="employeeWorkload" style="width: 95%">
      <el-table-column prop="months" label="时间"></el-table-column>
      <el-table-column prop="staffName" label="姓名"></el-table-column>
      <el-table-column prop="tel" label="电话"></el-table-column>
      <el-table-column prop="salary" label="总工资(元)"></el-table-column>
      <el-table-column prop="checkSalary" label="确认工资(元)"></el-table-column>
      <el-table-column prop="uncheckSalary" label="未确认工资(元)"></el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :page-count="pageTotal"
    ></el-pagination>
  </div>
</template>
<script>
import { workRecordselSum, salaryExport } from "@/api/workRecord";
import { getLast } from "@/util/time";
import moment from "moment";
export default {
  data() {
    return {
      tel: "",
      staffName: "",
      totalSalary: 0,
      totalCheckSalary: 0,
      totalUncheckSalary: 0,
      moment: moment(new Date()).format("YYYY-MM"),
      tableData: [],
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    search() {
      this.handleCurrentChange(1);
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.getList();
    },
    employeeWorkload(row) {
      this.$router.push({
        path: "/home/enterprise/personnel/employeeWorkload",
        query: {
          id: row.userId,
          staffName: row.staffName,
          tel: row.tel,
          month: row.months
        }
      });
    },
    salaryExports() {
      if (this.totalSalary != this.totalCheckSalary) {
        this.$message({
          type: "error",
          message: "有未确认的工序，不能导出！"
        });
        return;
      }
      // const time = getLast(new Date(this.moment));
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        enterpriseName: localStorage.getItem("company_name"),
        staffName: this.staffName,
        tel: this.tel,
        beginTime: moment(new Date(this.moment)).format("YYYY-MM"),
        endTime: moment(new Date(this.moment)).format("YYYY-MM"),
      };
      salaryExport(params, params.enterpriseName + params.beginTime);
    },
    getList() {
      const time = getLast(new Date(this.moment));
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        staffName: this.staffName,
        tel: this.tel,
        beginTime: moment(new Date(time[0])).format("YYYY-MM-DD"),
        endTime: moment(new Date(time[1])).format("YYYY-MM-DD"),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      workRecordselSum(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          var tableData = [];

          res.gridData.forEach(element => {
            element.months = moment(new Date(this.moment)).format("YYYY-MM")
            
            tableData.push(element);
          });
          this.totalSalary = res.totalSalary ? res.totalSalary : 0;
          this.totalCheckSalary = res.totalCheckSalary
            ? res.totalCheckSalary
            : 0;
          this.totalUncheckSalary = res.totalUncheckSalary
            ? res.totalUncheckSalary
            : 0;
          this.tableData = tableData;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
